<app-header></app-header> 

<!-- Page Header Start -->
<div class="container-fluid page-header py-5">
    <div class="container text-center pd-t-120 pd-b-120">
        <h1 class="display-5 text-white mb-4">Testimonials</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Pages</a></li>
                <li class="breadcrumb-item" aria-current="page">Testimonials</li>
            </ol>
        </nav>
    </div>
</div>
<!-- Page Header End -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->

<!-- Testimonial Start -->
<div class="container-fluid testimonial py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5" style="max-width: 600px;">
      <h5 class="color-primary">Our Testimonial</h5>
      <h1>Our Client Saying!</h1>
    </div>
    
    <!-- Angular Owl Carousel Component -->
    <owl-carousel-o [options]="customOptionsThree" class="testimonial-carousel">
      <ng-template carouselSlide *ngFor="let item of testimonials" [id]="item.id">
        
        <div class="testimonial-item border p-4">
          <div class="d-flex align-items-center">
            
            <!-- Client Image -->
            <div>
              <img [src]="item.image" [alt]="item.name" class="img-fluid rounded-circle">
            </div>
            
            <!-- Client Details & Rating -->
            <div class="ms-4">
              <h5 class="color-secondary">{{ item.name }}</h5>
              <p class="m-0 pb-3">{{ item.profession }}</p>

              <!-- Dynamic Star Ratings -->
              <div class="d-flex pe-5">
                <i *ngFor="let star of getStars(item.rating)" class="fas fa-star me-1 color-primary"></i>
              </div>
            </div>

          </div>
          
          <!-- Testimonial Comment -->
          <div class="border-top mt-4 pt-3">
            <p class="mb-0">{{ item.comment }}</p>
          </div>
        </div>

      </ng-template>
    </owl-carousel-o>

  </div>
</div>
<!-- Testimonial End -->